import Title from '@/agilis/components/Title/Title.vue'

export default {
  name: 'AppTabsAnagrafica',

  components: {
    Title
  },

  created: function () {
  },

  computed: {
  },

  methods: {
  }
}
